import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PORTFOLIO_DAILY_API =
  'INVESTMENT/FETCH_PORTFOLIO_DAILY_API';
const BACKFILL_INVESTCORE_PORTFOLIO_DAILY_API =
  'INVESTMENT/BACKFILL_PORTFOLIO_DAILY_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_DAILY_API,
  ({ user_id }) => ({
    endpoint: `/api/admin/portfolios/${user_id}/daily`,
    method: 'GET',
  })
);

export const backfillPortfolioDailyApiCall = createApiCall(
  BACKFILL_INVESTCORE_PORTFOLIO_DAILY_API,
  ({ user_id }) => ({
    endpoint: `/api/admin/portfolios/${user_id}/backfill-portfolio-daily`,
    method: 'POST',
  })
);

export default apiCall;
